import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "./UserContext"; // Import UserContext
import { Accordion, Card, useAccordionButton } from "react-bootstrap";
import { FaHome, FaChevronDown, FaChevronUp, FaClipboardList, FaBookOpen, FaBuilding, FaGlobeAmericas, FaNewspaper, FaTools } from "react-icons/fa"; // Import icons from react-icons
import { FaTasks } from "react-icons/fa";
import { MdAdminPanelSettings, MdPhoneIphone } from "react-icons/md";

import { MdOutlineQrCode2 } from "react-icons/md";

import { FaDownload } from "react-icons/fa";
import { IoPeopleSharp } from "react-icons/io5";

import { IoMdSchool } from "react-icons/io";
import { AiFillAlert } from "react-icons/ai";

const data = {
  "Panel de Control": [
    {
      name: "Panel de Control",
      url: "/",
      icon: <FaHome />,
      background: "#F0EBFA",
      roles: ["*"],
      excludedRoles: ["Recopilador/a"],
    },
    {
      name: "Ir a Sitio Web",
      url: process.env.REACT_APP_PUBLIC_WEBSITE_URL || "https://redmaestra.cl/",
      icon: <FaGlobeAmericas />,
      background: "#E7F4F8",
      roles: ["*"],
      excludedRoles: ["Recopilador/a"],
      external: true,
    },
    {
      name: "Administración",
      url: "/admin/",
      icon: <MdAdminPanelSettings />,
      background: "#F0F2F5",
      roles: ["*"],
      excludedRoles: ["Recopilador/a"],
    },
    {
      name: "Generar QR",
      url: "/api/generar_qr/",
      icon: <MdOutlineQrCode2 />,
      background: "#FFF4DC",
      roles: ["*"],
      excludedRoles: ["Recopilador/a"],
    },
    {
      name: "Manual de Usuario",
      url: "/manual",
      icon: <FaBookOpen />,
      background: "#EAF5EE",
      roles: ["*"],
      excludedRoles: ["Recopilador/a"],
    },
  ],

  "Descargar Excel": {
    icon: <FaDownload />,
    accent: "#5B3395",
    background: "#F2ECFA",
    items: [
      {
        name: "Maestras",
        url: "/api/descargas/maestras/",
        icon: <IoPeopleSharp />,
        color: "#9B00D6",
        roles: ["Gerencia"],
      },
      {
        name: "Interesadas",
        url: "/api/descargas/interesadas/",
        icon: <AiFillAlert />,
        color: "#C28A18",
        roles: ["Gerencia"],
      },
      {
        name: "Organizaciones",
        url: "/api/descargas/organizaciones/",
        icon: <FaBuilding />,
        color: "#17a2b8",
        roles: ["Gerencia"],
      },
      {
        name: "Programas",
        url: "/api/descargas/programas/",
        icon: <IoMdSchool />,
        color: "#28a745",
        roles: ["Gerencia"],
      },
      {
        name: "Iniciativas",
        url: "/api/descargas/iniciativas/",
        icon: <FaTasks />,
        color: "#6f42c1",
        roles: ["Gerencia"],
      },
      {
        name: "Novedades",
        url: "/api/descargas/novedades/",
        icon: <FaNewspaper />,
        color: "#B5354A",
        roles: ["Gerencia"],
      },
    ],
  },

  "Herramientas Internas": {
    icon: <FaTools />,
    accent: "#277A78",
    background: "#EAF6F4",
    items: [
      {
        name: "Prototipo Home Mobile",
        url: "/prototipo-home-mobile",
        icon: <MdPhoneIphone />,
        color: "#4d4595",
        roles: ["Soporte"],
      },
      {
        name: "Actualizar Whatsapp",
        url: "/whatsapp",
        icon: <IoPeopleSharp />,
        color: "#9B00D6",
        roles: ["Soporte"],
      },
      {
        name: "Coordinación de Tareas",
        url: "/recopilador/practica-ts",
        icon: <FaClipboardList />,
        color: "#17a2b8",
        roles: ["Soporte"],
      },
      {
        name: "Actualización de Perfiles",
        url: "/recopilador",
        icon: <FaClipboardList />,
        color: "#7B2CBF",
        roles: ["Soporte"],
      },
    ],
  },
};

function CustomToggle({ children, eventKey, callback }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    callback(eventKey),
  );

  return (
    <button
      type="button"
      className="nav-section-toggle"
      onClick={decoratedOnClick}
    >
      {children}
    </button>
  );
}

function Indice({ handleOffcanvasToggle }) {
  const [activeEventKey, setActiveEventKey] = useState(null);
  const { roles } = useContext(UserContext); // Access roles from UserContext

  const handleToggle = (eventKey) => {
    setActiveEventKey(activeEventKey === eventKey ? null : eventKey);
  };

  const canViewItem = (item) => {
    const requiredRoles = item.roles || [];
    const excludedRoles = item.excludedRoles || [];

    const hasItemExcludedRole = roles.some((role) =>
      excludedRoles.includes(role),
    );

    // Exclusion wins, but only when the item explicitly excludes that role.
    if (hasItemExcludedRole) {
      return false;
    }

    if (requiredRoles.includes("*")) {
      return true;
    }

    return roles.some((role) => requiredRoles.includes(role));
  };

  return (
    <div id="Indice">
      {data["Panel de Control"].map((item, index) => (
        canViewItem(item) && (
          <div
            className="Lonely-Index"
            key={index}
            style={{ "--nav-link-background": item.background }}
          >
            {item.external || item.url.startsWith("/admin") || item.url.startsWith("/api") ? (
              <a
                href={item.url}
                target={item.external ? "_blank" : undefined}
                rel={item.external ? "noreferrer" : undefined}
                className="standalone-nav-link"
              >
                {item.icon}
                <span className="nav-link-label">{item.name}</span>
              </a>
            ) : (
              <Link
                to={item.url}
                onClick={handleOffcanvasToggle}
                className="standalone-nav-link"
              >
                {item.icon}
                <span className="nav-link-label">{item.name}</span>
              </Link>
            )}
          </div>
        )
      ))}

      <Accordion>
        {Object.keys(data)
          .filter((key) => key !== "Panel de Control")
          .map((title, index) => {
            // Check if user has access to any item within the section
            const visibleItems = data[title].items.filter((item) => canViewItem(item));
            if (visibleItems.length === 0) {
              return null; // Skip section if no visible items
            }

            return (
              <Card
                key={title}
                className="nav-section-card"
                style={{
                  "--nav-section-accent": data[title].accent,
                  "--nav-section-background": data[title].background,
                }}
              >
                <Card.Header>
                  <CustomToggle
                    eventKey={index.toString()}
                    callback={handleToggle}
                  >
                    <span className="nav-section-icon">
                      {data[title].icon}
                    </span>
                    <span className="nav-section-title">{title}</span>
                    {activeEventKey === index.toString() ? (
                      <FaChevronUp className="nav-section-chevron" />
                    ) : (
                      <FaChevronDown className="nav-section-chevron" />
                    )}
                  </CustomToggle>
                </Card.Header>
                <Accordion.Collapse eventKey={index.toString()}>
                  <Card.Body>
                    {visibleItems.map((item, subIndex) => (
                      <div
                        key={subIndex}
                        className="nav-section-item"
                      >
                        <span className="nav-section-item-icon">
                          {item.icon}
                        </span>
                        {item.url.startsWith("/admin") ||
                        item.url.startsWith("/api") ? (
                          <a
                            href={item.url} // External admin URL
                            className="nav-section-link"
                          >
                            {item.name}
                          </a>
                        ) : (
                          <Link
                            to={item.url} // Internal React URL
                            onClick={handleOffcanvasToggle}
                            className="nav-section-link"
                          >
                            {item.name}
                          </Link>
                        )}
                      </div>
                    ))}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            );
          })}
      </Accordion>
    </div>
  );
}

export default Indice;
